import { type GridInitialState } from "@mui/x-data-grid-pro";

/** 「他ユーザー取得」列のフィールド名。各画面の列定義とフィルタ初期値の参照先を1つにする。 */
export const OTHER_USER_RESOURCE_FIELD = "isOtherUserResource";

/** 「自分で取得」operator値。各画面のotherUserResourceFilterOperatorsとフィルタ初期値の参照先を1つにする。 */
export const SELF_ACQUIRED_OPERATOR_VALUE = "isSelfAcquired";
/** 「他ユーザー取得」operator値。各画面のotherUserResourceFilterOperatorsとフィルタ初期値の参照先を1つにする。 */
export const OTHER_USER_ACQUIRED_OPERATOR_VALUE = "isOtherUserAcquired";

/** 共有ONのときのみ「自分で取得」の初期フィルタを返す。OFFはundefined = 既存挙動そのまま */
export const buildSelfAcquiredInitialState = (
  isSharableUser: boolean
): GridInitialState | undefined =>
  isSharableUser
    ? {
        filter: {
          filterModel: {
            items: [
              {
                id: 1,
                columnField: OTHER_USER_RESOURCE_FIELD,
                operatorValue: SELF_ACQUIRED_OPERATOR_VALUE,
              },
            ],
          },
        },
      }
    : undefined;
